/*
 * Copyright (c) 2025. Slimme Infrasoftware B.V. Apeldoorn /
 * Spin in het Web B.V. Apeldoorn.
 * Deze software mag alleen gebruikt / bekeken / gewijzigd worden
 * volgens de voorwaarden die zijn vastgelegd in de overeenkomst
 * tussen ATR en Slimme Infrasoftware B.V. en de onderliggende
 * overeenkomsten tussen Slimme Infrasoftware B.V en
 * Spin in het Web B.V.
 */

/*
 * regel-project.ts
 * Gegenereerd met Junie (AI), 06-10-2025
 * Auteur: Jelmer Jellema - Spin in het Web B.V
 * Subclass voor project-regels.
 */

import { Filtertoolregel } from '../filtertool-regels';

/**
 * Projectregel zonder extra velden.
 */
export class FiltertoolProjectregel extends Filtertoolregel {
  constructor(init?: Partial<Filtertoolregel>) { super('project', init as any); }
}
